module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/ecomm/ecomm-05-520e5e3bc198f494bee4126dd2fb8ca6.jpg";